/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replacement_Text_PlaceholderInputs */

const en_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replacement Text (e.g. hello world)`)
};

const fr_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte de remplacement (ex. bonjour le monde)`)
};

const de_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzungstext (z. B. Hallo Welt)`)
};

const it_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo sostitutivo (ad esempio, ciao mondo)`)
};

const ru_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заменяющий текст (например, "hello world")`)
};

const es_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de reemplazo (por ejemplo, hola mundo)`)
};

const zh_cn2_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替换文本（例如：hello world）`)
};

const ja_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置換テキスト（例：hello world）`)
};

const hi_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिस्थापन पाठ (उदाहरण के लिए, हेलो वर्ल्ड)`)
};

const pt_pt2_replacement_text_placeholder = /** @type {(inputs: Replacement_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de substituição (ex.: olá mundo)`)
};

/**
* | output |
* | --- |
* | "Replacement Text (e.g. hello world)" |
*
* @param {Replacement_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replacement_text_placeholder = /** @type {((inputs?: Replacement_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replacement_Text_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_replacement_text_placeholder(inputs)
	if (locale === "de") return de_replacement_text_placeholder(inputs)
	if (locale === "it") return it_replacement_text_placeholder(inputs)
	if (locale === "ru") return ru_replacement_text_placeholder(inputs)
	if (locale === "es") return es_replacement_text_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_replacement_text_placeholder(inputs)
	if (locale === "ja") return ja_replacement_text_placeholder(inputs)
	if (locale === "hi") return hi_replacement_text_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_replacement_text_placeholder(inputs)
	return en_replacement_text_placeholder(inputs)
});